function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMegapit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 26.458333 26.458334",
    id: "svg17343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-270.54165)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19401787,
      strokeOpacity: 1
    },
    id: "rect4518-85-9-8-83-00",
    width: 18.708866,
    height: 18.708866,
    x: 200.65627,
    y: 181.9474,
    transform: "rotate(44.999998)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#472a0f",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16491526,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-5-38-6-0",
    width: 15.902539,
    height: 15.902539,
    x: 202.05945,
    y: 183.35056,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 8.1256116,285.24361 -2.822567,2.82308 0.561205,0.5612 2.823083,-2.82256 z",
    id: "rect8773-0-4-6-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 7.2713986,283.10524 -3.577558,3.57807 0.561205,0.56121 3.577561,-3.57808 z",
    id: "rect8773-0-4-6-2-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 6.3355386,281.04748 -3.824055,3.82406 0.561205,0.5612 3.809587,-3.80959 0.01447,-0.0145 z",
    id: "rect8773-0-4-6-2-8-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 13.885982,285.47098 -5.3872684,5.38779 0.561208,0.5612 5.3872684,-5.38778 z",
    id: "rect8773-0-4-6-2-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 10.766793,285.59656 -3.7651454,3.76514 0.561205,0.56121 3.7651464,-3.76515 z",
    id: "rect8773-0-4-6-2-8-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 23.418219,281.92546 -11.926406,11.9264 0.561207,0.56121 11.926404,-11.9264 z",
    id: "rect8773-0-4-6-2-87"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 21.921151,280.42891 -3.229777,3.23029 0.561205,0.56121 3.230295,-3.23029 z m -5.359879,5.35936 -6.5665254,6.56653 0.5617244,0.56172 6.566524,-6.56652 z",
    id: "rect8773-0-4-6-2-8-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#fefefe",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.14142573,
      strokeOpacity: 1
    },
    d: "m 4.7408046,280.06666 -1.5875,1.5875 h 3.72587 v 3.70417 1.45521 h 1.058334 11.6416664 v -1.45521 -3.70417 h 3.889685 l -1.5875,-1.5875 h -3.889685 v 1.5875 3.70417 H 8.4666746 v -3.70417 -1.5875 h -2.116666 z",
    id: "rect8773-0-4-3"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 280.06665,
    x: 5.2916737,
    height: 0.79374999,
    width: 15.875,
    id: "rect8773-0-3-4-1-6",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.14142574,
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMegapit);
export default __webpack_public_path__ + "static/media/icon-megapit.bbce31df0af714e95d04683f252c3ce5.svg";
export { ForwardRef as ReactComponent };